import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProfileAccountDetails from "./profileEditableSection/ProfileAccountDetails";
import styles from "./ProfilePersonalDetails.module.css"
import ProfileAddressesDetails from "./profileAdressesDetails/ProfileAddressesDetails";
import useDataFetch from "../../../hooks/useDataFetch";

export interface UserProfileAddressDTO {
    id: number,
    firstname: string,
    lastname: string,
    city: string,
    zip: string,
    street: string,
    streetNumber: string,
}

export interface UserProfileDTO {
    email: string,
    phoneNumber: string,
    addresses: UserProfileAddressDTO[];
}

const ProfilePersonalDetails = () => {

    const {data: profile} = useDataFetch<UserProfileDTO>(`/profile`, true, true)

    return (
        <Box sx={{
            width: "100%",
            backgroundColor: 'secondary.main',
            alignContent: 'center',
            height: "100%",
        }}>

            <Box
                sx={{
                    backgroundColor: "secondary.main",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div className={styles.content}>
                    <div className={styles.realContent}>
                        <Typography
                            variant={"secondVariant"}
                            sx={{
                                fontSize: {xs: 25, sm: 30}
                            }}
                        >
                            Profil
                        </Typography>

                        <Typography
                            p={"5px"}
                            variant={"secondVariant"}
                            mt={2}
                            sx={{
                                fontSize: {xs: 18, sm: 22}
                            }}
                            textAlign={"left"}
                        >
                            Informations personnelles
                        </Typography>

                        {profile && (
                            <ProfileAccountDetails profile={profile}/>
                        )}

                        <Typography
                            p={"5px"}
                            variant={"secondVariant"}
                            mt={6}
                            sx={{
                                fontSize: {xs: 18, sm: 22}
                            }}
                            textAlign={"left"}
                        >
                            Adresses
                        </Typography>

                        {profile && (
                            <ProfileAddressesDetails profile={profile}/>
                        )}

                    </div>
                </div>

            </Box>


        </Box>
    );
}

export default ProfilePersonalDetails